
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-links',
    templateUrl: 'links.component.html',
  standalone: false
})

export class LinksComponent implements OnInit {
    constructor() { }

    ngOnInit() {document.querySelector("body").classList.remove("opened"); }
}
